import { createContext, useContext, useState, useEffect } from "react";
import { api, firstOfMonthISO, todayISO } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FiltersContext = createContext(null);

export function FiltersProvider({ children }) {
  const { user } = useAuth();
  const [executives, setExecutives] = useState([]);
  const [selectedExecId, setSelectedExecId] = useState("all");
  const [dateFrom, setDateFrom] = useState(firstOfMonthISO());
  const [dateTo, setDateTo] = useState(todayISO());

  useEffect(() => {
    if (!user) return;
    api.get("/executives", { params: { status: "Active" } }).then((r) => {
      setExecutives(r.data);
      if (user.role === "executive" && user.executive_id) {
        setSelectedExecId(user.executive_id);
      }
    }).catch(() => {});
  }, [user]);

  return (
    <FiltersContext.Provider value={{
      executives, setExecutives,
      selectedExecId, setSelectedExecId,
      dateFrom, setDateFrom,
      dateTo, setDateTo,
    }}>
      {children}
    </FiltersContext.Provider>
  );
}

export const useFilters = () => useContext(FiltersContext);
